"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-genesio-atesino": {
    "11be27e2": [{
      "hkey": "0efd8292",
      "slug": "san-genesio-atesino",
      "name": "San Genesio Atesino",
      "primary": true,
      "skipSearch": false
    }],
    "cologna-glania": [{
      "hkey": "0efd8292",
      "slug": "san-genesio-atesino",
      "name": "San Genesio Atesino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0bbb5c03": [{
      "hkey": "0efd8292",
      "slug": "san-genesio-atesino",
      "name": "San Genesio Atesino",
      "primary": true,
      "skipSearch": false
    }],
    "montoppio": [{
      "hkey": "0efd8292",
      "slug": "san-genesio-atesino",
      "name": "San Genesio Atesino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e123a12": [{
      "hkey": "7a86b5e0",
      "slug": "valas",
      "name": "Valas",
      "primary": true,
      "skipSearch": false
    }],
    "valas-velasio": [{
      "hkey": "7a86b5e0",
      "slug": "valas",
      "name": "Valas",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;